import axios from 'axios';
import {
    LINK_API,
    API_HEADER
} from '../../../constants/API'
import {
    CREATE_LINK_LOADING
} from '../types';
import { message } from 'antd';

export default (data) => {
    return async (dispatch, getState) => {
        try {
            dispatch({
                type: CREATE_LINK_LOADING,
                creatingLink: true
            })
            const { token, dbUser } = getState().UserReducer;
            const postData = { ...data, userId: dbUser.id }
            await axios.post(`${LINK_API}`, postData, API_HEADER(token))
            dispatch({
                type: CREATE_LINK_LOADING,
                creatingLink: false
            })
            return true;

        } catch(e) {
            if (e && e.response && e.response.data) {
                message.error(String(e.response.data))
            }            
            dispatch({
                type: CREATE_LINK_LOADING,
                creatingLink: false
            })
            return false

        }
    }
}